import { ConfirmationDialog } from './ConfirmationDialog'

export * from "./hooks/useConfirm"

export default ConfirmationDialog;